<template>
    <div @click="$emit('changePage')">
        <div v-if="isWhite" class="button white">{{text}}</div>
        <div v-else class="button">{{text}}</div>
    </div>
</template>
<script>
export default {
    name:"myButton",
    props:{
        text:{
            type:String
        },
        isWhite:{
            type:Boolean,
            default:false
        }
    }
}
</script>
<style lang="stylus" scoped>
.button 
    font-size:14px;
    color:#999;
    padding:6px 20px;
    border:1px solid #999;
    border-radius:20px; 
    display:inline-block;
    margin-top:30px;
    line-height:25x;
    cursor:pointer;
    margin-bottom:40px;
    &:hover
        color:#2b83ff
        border-color:#2b83ff
.white
    color:#fff;
    border:1px solid #fff;
</style>